import "core-js/modules/es.array.includes.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseComplexToggle",
  props: {
    labels: {
      type: Object,
      required: true
    },
    modelValue: {
      type: String,
      "default": ""
    },
    type: {
      type: String,
      "default": "full"
    },
    mode: {
      type: String,
      "default": ""
    },
    btnBgColor: {
      type: String,
      "default": "tw-bg-w-lavender-bordered"
    },
    // eslint-disable-next-line max-len
    borderContainerColor: {
      type: String || "tw-border-w-secondary" || "tw-border-w-dark-primary" || "tw-border-w-lavender" || "tw-border-w-cultured" || "tw-border-w-carbon" || "tw-border-w-gray" || "tw-border-w-warning" || "tw-border-w-danger" || "border-facile" || "border-mortgage",
      "default": "tw-border-w-secondary"
    }
  },
  emits: ["update:modelValue"],
  data: function data() {
    return {
      texActiveToggleColor: "tw-text-white"
    };
  },
  computed: {
    leftBtn: function leftBtn() {
      return this.$refs.leftBtn;
    },
    rightBtn: function rightBtn() {
      return this.$refs.rightBtn;
    },
    dynamicBg: function dynamicBg() {
      return this.$refs.dynamicBg;
    }
  },
  created: function created() {
    var textBlack = ["tw-bg-w-cultured-bordered", "tw-bg-w-gray", "tw-bg-w-warning", "tw-bg-w-lavender-bordered"];
    if (textBlack.includes(this.btnBgColor)) this.texActiveToggleColor = "tw-text-w-black";
  },
  mounted: function mounted() {
    if (this.btnBgColor)
      //Positioning the dynamic bg
      if (this.labels.leftToggle.checked) {
        this.moveDynamicBgToLeft();
        this.emitLeftLabel();
      } else if (this.labels.rightToggle.checked) {
        this.moveDynamicBgToRight();
        this.emitRightLabel();
      }
  },
  methods: {
    handleToggle: function handleToggle(btn) {
      if (!this.leftBtn || !this.rightBtn) return;
      if (btn === "left-btn") {
        this.moveDynamicBgToLeft();
        this.$emit("update:modelValue", this.labels.leftToggle.label);
      } else {
        this.moveDynamicBgToRight();
        this.$emit("update:modelValue", this.labels.rightToggle.label);
      }
    },
    moveDynamicBgToLeft: function moveDynamicBgToLeft() {
      var _a, _b, _c, _d;
      (_a = this.dynamicBg) === null || _a === void 0 ? void 0 : _a.classList.remove("translateX-right");
      (_b = this.dynamicBg) === null || _b === void 0 ? void 0 : _b.classList.add("translateX-left");
      (_c = this.leftBtn) === null || _c === void 0 ? void 0 : _c.classList.add("base-complex-toggle-active", this.texActiveToggleColor);
      (_d = this.rightBtn) === null || _d === void 0 ? void 0 : _d.classList.remove("base-complex-toggle-active", this.texActiveToggleColor);
    },
    moveDynamicBgToRight: function moveDynamicBgToRight() {
      var _a, _b, _c, _d;
      (_a = this.dynamicBg) === null || _a === void 0 ? void 0 : _a.classList.remove("translateX-left");
      (_b = this.dynamicBg) === null || _b === void 0 ? void 0 : _b.classList.add("translateX-right");
      (_c = this.rightBtn) === null || _c === void 0 ? void 0 : _c.classList.add("base-complex-toggle-active", this.texActiveToggleColor);
      (_d = this.leftBtn) === null || _d === void 0 ? void 0 : _d.classList.remove("base-complex-toggle-active", this.texActiveToggleColor);
    },
    emitLeftLabel: function emitLeftLabel() {
      this.$emit("update:modelValue", this.labels.leftToggle.label);
    },
    emitRightLabel: function emitRightLabel() {
      this.$emit("update:modelValue", this.labels.rightToggle.label);
    }
  }
});